import ActivationAbogados from "./activationAbogados";
export default ActivationAbogados;
